import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

import Navbar from './Navbar';
import Slide from './Slide';
import Footer from './Footer';
import { fetchShowcase } from '../api';
import '../styles/FullscreenShowcase.scss';

const FullscreenShowcase = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const swiperRef = useRef(null);

  // Fetch showcase data from API
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchShowcase()
      .then((data) => {
        if (!cancelled) {
          setSlides(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      });
    return () => { cancelled = true; };
  }, []);

  const handleSlideChange = (swiper) => {
    setCurrentSlide(swiper.activeIndex);
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="fullscreen-showcase-wrapper loading-state">
          <div className="loading-spinner" />
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="fullscreen-showcase-wrapper error-state">
          <p className="error-message">Unable to load content. Please try again later.</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="fullscreen-showcase-wrapper">
        <Swiper
          ref={swiperRef}
          modules={[Mousewheel, Pagination]}
          direction="vertical"
          speed={600}
          slidesPerView={1}
          mousewheel={true}
          keyboard={false}
          allowTouchMove={true}
          pagination={{
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: (index) => `<span class="swiper-pagination-bullet">0${index + 1}</span>`
          }}
          onSlideChange={handleSlideChange}
          className="swiper"
        >
          {slides.map((item, index) => (
            <SwiperSlide key={item.id || index}>
              <Slide slide={item} index={index} />
            </SwiperSlide>
          ))}
          <SwiperSlide className="footer-slide" key="footer">
            <Footer />
          </SwiperSlide>
        </Swiper>

        <div className="swiper-pagination-wrapper">
          <div className="swiper-pagination"></div>
        </div>
      </div>
    </>
  );
};

export default FullscreenShowcase;
